import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoaderService } from '@app/core/business/ui/loader.service';
import { AuthenticationService } from '@app/core/business/user/authentication.service';
import { ContextService } from '@app/core/service/context.service';
import { filter, pairwise, switchMap, take, tap } from 'rxjs/operators';
import { StatusService } from './core/service/status.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { error } from 'console';
import { BehaviorSubject, interval, of, Subject, timer } from 'rxjs';
import { AppConfigurationService } from './core/service/app-configuration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public loadApp = true;
  public statusMessage: string;
  public headerFooter: boolean;



  constructor(private location: Location, private router: Router, public contextService: ContextService, public authenticationService: AuthenticationService,
    public loaderService: LoaderService, private statusService: StatusService, private translateService: TranslateService, private cdRef: ChangeDetectorRef,
    private appConfig: AppConfigurationService) {
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  ngOnInit() {
    this.appConfig.load();

    //Ajout par BOE pour essayer de masquer le header
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.headerFooter = (event.url !== '/login')
      }
    });

    this.statusService.getStatus().subscribe(x => {
      

      this.loadApp = true;


      this.contextService.context$.subscribe(context => {
        const path = this.location.path();

        if (path.startsWith('/terms-of-service/validate/')) {
            return; // Ne fait rien, reste sur la page publique.
        }

        if (!context.companyCode && !context.customerCode && !context.orderCode) {
          this.router.navigateByUrl('/context/companies');
        }
        else if (context.companyCode && !context.customerCode) {
          this.router.navigateByUrl('/context/customers');
        }
        else if (context.companyCode && context.customerCode && !context.termsOfServiceValidated) {
          this.router.navigateByUrl('/dashboard/terms-of-service');
        }
        else if (context.companyCode && context.customerCode && context.termsOfServiceValidated && path.startsWith('/dashboard/terms-of-service')) {
          this.router.navigateByUrl('/dashboard');
        }
        else if (context.companyCode && context.customerCode && path.startsWith('/context')) {
          this.router.navigateByUrl('/dashboard');
        }
      });

      // If the company changes (and had a value previously), we redirect the user to the dashboard
      this.contextService.context$.pipe(pairwise()).subscribe(contexts => {
        if (contexts[0].customerCode && contexts[1].customerCode && contexts[0].customerCode !== contexts[1].customerCode && contexts[1].termsOfServiceValidated) {
          this.router.navigateByUrl('/dashboard');
        }
      });
    }, error => {
        this.loadApp = false;
        this.statusMessage = this.translateService.instant('app.unavailable');
    });
  }

  ngOnDestroy() { }

}
